/**
 * Duration tokens, in seconds.
 *
 * Seconds rather than milliseconds because GSAP works in seconds — storing
 * them in ms would mean a conversion at every callsite, and eventually a
 * missed one. The SASS side (styles/abstracts/_variables.scss) holds the
 * same values expressed for CSS.
 *
 * Scale from DESIGN_SYSTEM.md: 200ms / 400ms / 800ms / 1600ms.
 *
 */
export const DURATION = {
  /** Immediate feedback: hovers, button states. */
  fast: 0.2,
  /** Default for most UI transitions. */
  base: 0.4,
  /** Deliberate: panels, overlays, section reveals. */
  slow: 0.8,
  /** Large, slow arrivals: hero entrances. */
  cinematic: 1.6,
} as const;

export type DurationToken = keyof typeof DURATION;

/**
 * Stagger presets, in seconds. Kept alongside durations because a stagger
 * that outlasts its own animation reads as a queue rather than a group.
 */
export const STAGGER = {
  tight: 0.03,
  base: 0.06,
  loose: 0.12,
} as const;
